// extracted by mini-css-extract-plugin
module.exports = {"swatchIcon":"cu","mobile":"du"};